// DueFollowUps.jsx
import styles from "./DueFollowUps.module.css";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import { FiEdit2 } from "react-icons/fi";
import { HiOutlineDocumentText } from "react-icons/hi2";

const colorPresets = [
  { rgb: "39, 174, 96" }, // --Success_Color
  { rgb: "192, 57, 43" }, // --Error_Color
  { rgb: "230, 126, 34" }, // --Warning_Color
  { rgb: "41, 128, 185" }, // --Info_Color
];


const baseData = [
  {
    name: "John Steeve",
    lastFollowDate: "03/06/2025",
    dueDate: "27/06/2025",
  },
  {
    name: "John Steeve",
    lastFollowDate: "03/06/2025",
    dueDate: "27/06/2025",
  },
  {
    name: "John Steeve",
    lastFollowDate: "03/06/2025",
    dueDate: "28/06/2025",
  },
];

const DueFollowUps = () => {
  const dueFollowData = baseData.map((item) => {
    const random =
      colorPresets[Math.floor(Math.random() * colorPresets.length)];
    const textColor = `rgb(${random.rgb})`;
    const circleBgColor = `rgb(${random.rgb})`;
    const circleTextColor = "#ffffff"; // force white text for visibility
    return {
      ...item,
      bgColor: `rgba(${random.rgb}, 0.2)`,
      textColor,
      circleTextColor,
      circleBgColor,
    };
  });

  const handleViewAll = () => {
    console.log("View All Due Follow Ups clicked");
  };

  return (
    <div className={styles.container}>
      <div className={styles.headerRow}>
        <HeadingAndIcon
          icon={<HiOutlineDocumentText />}
          heading="Due follow ups"
        />
        <div className={styles.editWrapper}>
          <FiEdit2 size={16} /> <span>This Month</span>
        </div>
      </div>

      <div className={styles.list}>
        {dueFollowData.map((item, i) => (
          <div
            key={i}
            className={styles.dataCard}
            style={{ backgroundColor: item.bgColor }}
          >
            <LogoWithName
              name={item.name}
              dateRange={`Last follow up : ${item.lastFollowDate}`}
              color={item.textColor} // ✅ for name
              bgColor={item.circleBgColor} // ✅ for circle background
              circleTextColor={item.circleTextColor} // ✅ now applied to the letter inside the circle
            />

            <span className={styles.dateText} style={{ color: item.textColor }}>
              {item.dueDate}
            </span>
          </div>
        ))}
      </div>

      <div className={styles.footer}>
        <span className={styles.viewAll} onClick={handleViewAll}>
          View All
        </span>
      </div>
    </div>
  );
};

export default DueFollowUps;
